import { render, staticRenderFns } from "./ImagePlaceholderIcon.vue?vue&type=template&id=987defd2&"
import script from "./ImagePlaceholderIcon.vue?vue&type=script&lang=js&"
export * from "./ImagePlaceholderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports